<template>
  <div class="forgot_container">
    <div class="forgot_panel">
      <h2> Reset Password </h2>
      <div class="p-fluid">
        <form @submit.prevent="onSubmit()">
          <div class="p-field">
            <span class="p-input-icon-left">
              <i class="pi pi-user" />
              <InputText 
                type="text" 
                v-model.trim="$v.user.email.$model" 
                placeholder="Email" 
                :class="{'is-danger': $v.user.email.$error}"
              />
            </span>
            <div class="error" v-if="$v.user.email.$error"> 
              {{ emailError }} 
            </div>
          </div>
          <div class="p-field">
            <Button label="Submit" type="submit"/>
          </div>
        </form>

        <div class="p-field">
          <span class="forgot_links">
            <router-link class="p_link" to="/login"> 
              Back to Login 
            </router-link>
          </span>
        </div>
      </div>
      <Toast position="bottom-center" />
    </div>
  </div>
</template>

<script>
import { fb_auth } from '../firebase'
import { required, email } from "vuelidate/lib/validators"

export default {
  name: "ForgotPassword",
  components: {  },
  data() {
    return {
      user: {
        email: "",
      },
    }
  },
  validations: {
    loading: false,
    user: {
      email: {
        required,
        email,
      },
    }
  },
  computed: {
    emailError() {
      return this.$v.user.email.$error
        ? this.$v.user.email.required 
          ? "* Email is invalid" 
          : "* Email is required"
        : "";
    },
  },
  methods: {
    onSubmit() {
      this.$v.user.$touch();
      // if it's still pending or an error is returned, don't submit
      if (this.$v.user.$pending || this.$v.user.$error) {
        return;
      }

      this.loading = true;
      fb_auth
        .sendPasswordResetEmail(this.user.email)
        .then(() => {
          this.$router.push({ path: '/login' })
        })
        .catch(error => {
          const { code, message } = error;
          this.loading = false;
          this.$toast.add({
            severity:'error', 
            summary: code, 
            detail: message, 
            life: 3000
          })
        })
    }
  },
};
</script>

<style lang="scss" scoped>
@import '../assets/theme.scss';

.forgot_container{
  display: flex;
  justify-content: center;
  color: $text;

  .forgot_panel {
    top: 25%;
    width: 100%;
    max-width: 380px;
    height: 250px;
    position: absolute;
    background-color: white;
    margin: 0 25px 25px 25px;
    border-radius: 7px;
    box-shadow: 0 2px 1px -1px rgba(0,0,0,.2), 0 1px 1px 0 rgba(0,0,0,.14), 0 1px 3px 0 rgba(0,0,0,.12);
    padding: 2rem;
  }
  .forgot_links {
    color: #666666;
    font-size: 15px;
    display: flex;
    justify-content: flex-end;
  }
  .forgot_remember {
    margin-left: 5px;
  }
  .p_link {
    color: $primary;
    text-decoration: none;
  }
}

.is-danger {
  border-color: $primary;
} 
.error {
  display: flex;
  color: $primary;
  font-size: 0.8rem;
  margin-left: 10px;
  margin-top: 0.3205rem;
  margin-bottom: -0.6925rem;
}
</style>